import React, { useState } from 'react';

const SearchAndFilterBar = ({ searchTerm, setSearchTerm, filters, setFilters }) => {
    // Local state to hold the live value of the input field
    const [inputValue, setInputValue] = useState(searchTerm);

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: { ...prev[key], value: value },
        }));
    };

    const handleSearch = () => {
        setSearchTerm(inputValue);
    };

    const handleClear = () => {
        setInputValue('');
        setSearchTerm('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="search-filter-bar">
            <div className="search-input-wrapper">
                {/* The magnifier icon span has been removed */}
                <input
                    type="text"
                    placeholder="Search by name or ID..."
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <div className="search-buttons">
                <button className="search-button" onClick={handleSearch}>Search</button>
                <button className="clear-button" onClick={handleClear}>Clear</button>
            </div>
            <div className="filters-wrapper">
                {Object.entries(filters).map(([key, filter]) => (
                    <div key={key} className="filter-group">
                        <label>{filter.label}</label>
                        <select
                            value={filter.value}
                            onChange={(e) => handleFilterChange(key, e.target.value)}
                        >
                            <option value="all">All</option>
                            {/* FIX: Check if options exist before mapping */}
                            {(filter.options || []).map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SearchAndFilterBar;
